import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.pages.AppProjectsPage.';
  public static readonly projectSummaryTitle = `${Id.prefix}projectSummaryTitle`;
}

export class LangAppProjectsPage {
  private constructor() {}
  public static projectSummaryTitle(): string {
    return interpolate(Id.projectSummaryTitle);
  }
}

export class AppProjectsPageModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.projectSummaryTitle, "{{glossary 'project'}} Summary", 'Title for the projects summary page');
  }
}
